import { Box } from "@mui/material";
import { eventTypeBadgeLabel } from "./eventTypes";

const LOOK: Record<string, { bg: string; fg: string; border: string }> = {
  draft: { bg: "transparent", fg: "#FFFFFF", border: "1px dashed rgba(255,255,255,0.8)" },
  newRequest: { bg: "#F4F4F6", fg: "#0E121E", border: "1px solid #F4F4F6" },
  pendingApproval: { bg: "#F4F4F6", fg: "#0E121E", border: "1px solid #F4F4F6" },
};

/** Small stage tag for rows that are not approved yet (drafts, new requests, estimates sent). */
export default function EventTypeBadge({ lifecycle }: { lifecycle?: string | null }) {
  const look = lifecycle ? LOOK[lifecycle] : undefined;
  const label = eventTypeBadgeLabel(lifecycle);
  if (!look || !label) return null;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        fontSize: "12px",
        lineHeight: "18px",
        fontWeight: 600,
        padding: "0 8px",
        borderRadius: "6px",
        whiteSpace: "nowrap",
        background: look.bg,
        color: look.fg,
        border: look.border,
      }}
    >
      {label}
    </Box>
  );
}
